import { Box } from '@chakra-ui/react';
import { ServicePage as Props, ServiceData } from '../../types';
import ArticleContainer from '../ArticleContainer';
import HeroSplit from '../HeroSplit';
import Breadcrumb from '../Breadcrumb';
import ButtonLink from '../ButtonLink';
import DescList, { ListItem } from '../DescriptionList';
import { useTranslation } from '../../lib/hooks.context';
import { BlockRenderer } from '../Fields/BlockRenderer';

const ServiceDataList = (data: ServiceData) => (
  <DescList
    mb="7"
    display="grid"
    gridColumnGap="5"
    overflowX="auto"
    gridTemplateColumns="repeat(auto-fit, minmax(0, max-content))"
    width="100%"
  >
    {Object.values(data)
      .filter(Boolean)
      .map(({ value, label }) => (
        <ListItem
          term={label}
          key={label}
          color="secondaryColor"
          textStyle="xs"
          gridRow="1"
          mb="2"
          sx={{ '+ dd': { gridRow: 2, maxW: '225px' } }}
        >
          {value}
        </ListItem>
      ))}
  </DescList>
);

const ServicePage = ({
  post_title: title,
  post_excerpt: leadText,
  featured_image,
  featured_video,
  fields,
  data,
}: Props) => {
  const t = useTranslation();
  const showServiceOrderRequest = fields.some(
    (f) => f.__name === 'mhy/service-order-request',
  );

  return (
    <ArticleContainer>
      <Box>
        <Breadcrumb mb="4" />
        <HeroSplit
          title={title}
          leadText={leadText}
          image={featured_image}
          video={featured_video}
        >
          {data ? <ServiceDataList {...data} /> : null}
          {showServiceOrderRequest ? (
            <ButtonLink
              link={{
                url: '#service-request',
                title: t('service_request_offer'),
              }}
              variant="solidGreen"
            />
          ) : null}
        </HeroSplit>
      </Box>
      <BlockRenderer blocks={fields} />
    </ArticleContainer>
  );
};

export default ServicePage;
